import { useState, useEffect } from 'react';

const useViewMode = (storageKey, initialValue = 'list') => {
    const [viewMode, setViewMode] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        return saved || initialValue;
    });

    useEffect(() => {
        localStorage.setItem(storageKey, viewMode);
    }, [viewMode, storageKey]);

    return [viewMode, setViewMode];
};

export default useViewMode;